/* eslint-disable */
window.__publicpath__ = window.serverContext && window.serverContext.PublicPath ?
  window.serverContext.PublicPath : window.location.origin + '/campaign/pmaxlitelanding/';
__webpack_public_path__ = window.__publicpath__;